import { ActionReducerMap } from '@ngrx/store';
import { SearchStates } from '../states';
import { searchReducer } from './search.reducers';

export const SearchModuleReducers: ActionReducerMap<SearchStates> = {
  search: searchReducer
};
